/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Heart = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M11.3659 4.79808L12.2253 5.66556L13.0864 4.79808C15.4619 2.40064 19.3133 2.40064 21.6888 4.79808C24.0643 7.19551 24.0158 10.7106 21.6888 13.48C20.1374 15.3262 16.9366 18.1306 12.0864 21.8932C7.42245 18.1306 4.31483 15.3262 2.76348 13.48C0.436471 10.7106 0.387997 7.19551 2.76348 4.79808C5.13897 2.40064 8.9904 2.40064 11.3659 4.79808ZM3.82901 5.85385C2.03819 7.66122 2.04867 10.2976 3.91189 12.515C5.24575 14.1024 7.87705 16.513 11.7771 19.7088L12.104 19.976L12.4275 19.7224C16.3589 16.6224 19.0274 14.2603 20.4027 12.6761L20.5404 12.515C22.4036 10.2976 22.4141 7.66122 20.6232 5.85385C18.8346 4.04872 15.9405 4.04872 14.151 5.85476L13.29 6.72225L12.2244 7.79583L11.1598 6.72128L10.3004 5.85385C8.51175 4.04872 5.61762 4.04872 3.82901 5.85385Z"
                        fill={color}
                    />
                </svg>
        );
    };
